/**
 * Exponential backoff for outbox push retries (docs/08 §4).
 * Scheduler owns the delay between flushOutbox() calls; entries are tried
 * at most once per flush invocation.
 */

/** Stop retrying after this many failed attempts (docs/08 §4). */
export const MAX_PUSH_ATTEMPTS = 5;

const BACKOFF_BASE_MS = 1_000;
const BACKOFF_MAX_MS = 60_000;

/** Delay before the next flush attempt given `attempts` already recorded. */
export function pushBackoffMs(attempts: number): number {
  if (attempts <= 0) return 0;
  const exp = Math.min(attempts - 1, 16);
  const ms = BACKOFF_BASE_MS * 2 ** exp;
  return Math.min(ms, BACKOFF_MAX_MS);
}
